/* eslint-disable @typescript-eslint/no-restricted-imports */
import "./Misc/symbolMetadataPolyfill";
export * from "./Actions/index";
export * from "./Animations/index";
export * from "./assetContainer";
export * from "./Audio/index";
export * from "./AudioV2/index";
export * from "./BakedVertexAnimation/index";
export * from "./Behaviors/index";
export * from "./Bones/index";
export * from "./Buffers/index";
export * from "./Cameras/index";
export * from "./Collisions/index";
export * from "./Compat/index";
export * from "./Compute/index";
export * from "./Culling/index";
export * from "./Debug/index";
export * from "./DeviceInput/index";
export * from "./Engines/index";
export * from "./Events/index";
export * from "./FlowGraph/index";
export * from "./FrameGraph/index";
export * from "./Gamepads/index";
export * from "./Gizmos/index";
export * from "./Helpers/index";
export * from "./Instrumentation/index";
export * from "./Layers/index";
export * from "./LensFlares/index";
export * from "./Lights/index";
export * from "./Loading/index";
export * from "./Materials/index";
export * from "./Maths/pure";
export * from "./Meshes/index";
export * from "./Misc/index";
export * from "./Morph/index";
export * from "./Navigation/index";
export * from "./node";
export * from "./ObjectModel/index";
export * from "./Offline/index";
export * from "./Particles/index";
export * from "./Physics/index";
export * from "./PostProcesses/index";
export * from "./Probes/index";
export * from "./Rendering/index";
export * from "./scene";
export * from "./sceneComponent";
export * from "./SmartAssets/index";
export * from "./Sprites/index";
export * from "./States/index";
export * from "./types";
export * from "./XR/index";

import "./Shaders/ShadersInclude/sceneFragmentDeclaration";
